<template>
  <div>
    <mia-settings-basics-invoice-form />
    <mia-settings-basics-invoice-sepa-form class="mt-16" />
    <mia-settings-basics-invoice-pricing-form
      v-if="isRoot"
      class="mt-16"
    />
  </div>
</template>

<script>
import InvoiceForm from '@/components/settings/forms/InvoiceForm.vue'
import InvoicePricingForm from '@/components/settings/forms/InvoicePricingForm.vue'
import InvoiceSepaForm from '@/components/settings/forms/InvoiceSepaForm.vue'

export default {
  name: 'MiaSettingsBasicsInvoice',

  components: {
    'mia-settings-basics-invoice-form': InvoiceForm,
    'mia-settings-basics-invoice-pricing-form': InvoicePricingForm,
    'mia-settings-basics-invoice-sepa-form': InvoiceSepaForm
  }
}
</script>
